// services/reportService.js
import { BASE_URL } from "../components/BaseUrl";
import { decryptToken } from "../Utlis/Encryption";

// Get auth token
const getToken = () => {
  const rawToken = localStorage.getItem("token");
  return rawToken ? decryptToken(rawToken) : null;
};

// Report API Service
export const ReportService = {
  // Generate any report type. Omit workerId for a company-wide report scoped by companyId.
  generateReport: async (params) => {
    const token = getToken();
    const response = await fetch(`${BASE_URL}/public/reports/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // Convenience methods for specific reports
  getAttendanceReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "attendance",
      startDate,
      endDate,
      workerId,
      companyId,
      ...filters,
    });
  },

  getTaskReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "task",
      startDate,
      endDate,
      workerId,
      companyId,
      ...filters,
    });
  },

  getPayrollReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "payroll",
      startDate,
      endDate,
      workerId,
      companyId,
      ...filters,
    });
  },

  getReimbursementReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "reimbursement",
      startDate,
      endDate,
      workerId,
      companyId,
      ...filters,
    });
  },

  getWorkerPerformanceReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "worker_performance",
      startDate,
      endDate,
      workerId,
      workerIds: workerId ? [workerId] : undefined,
      companyId,
      showChartData: true,
      ...filters,
    });
  },

  getScheduleComplianceReport: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "schedule_compliance",
      startDate,
      endDate,
      workerId,
      companyId,
      showChartData: true,
      ...filters,
    });
  },

  // Daily breakdown — per-day scheduled vs actual rows + period summary block
  getScheduleComplianceDaily: async (startDate, endDate, workerId, companyId, filters = {}) => {
    return ReportService.generateReport({
      type: "schedule_compliance",
      startDate,
      endDate,
      workerId,
      companyId,
      showDailyBreakdown: true,
      ...filters,
    });
  },
};

export default ReportService;
